// import "./App.css";
import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, RequireAuth, SsoReentry } from './Auth/AuthProvider';
import { LoginPage, PasswordSetupPage, TenantAdminSetupPage } from './Auth/AuthPages';
import { tenantAdminRoutes } from './TenantAdmin/TenantAdminShell';
import { platformAdminRoutes } from './PlatformAdmin/PlatformShell';
import Layout from "./Dashboard/Layout";
import HomePage from "./HomePage/HomePage";
import JSONFormatter from "./Tools/JSONTools/JSONformatter";
import JSONValidator from "./Tools/JSONTools/JSONValidator";
import JSONEvaluator from "./Tools/JSONTools/JSONEvaluator";
import JSONConvertor from "./Tools/JSONTools/JSONConvertor";
import ToolsLayout from "./HomePage/ToolsPage";
import JSONMultiDiff from "./Tools/JSONTools/JSONMultiDiff";
import JSONMultiDiffViewer from "./Tools/JSONTools/JSONMultiDiffViewer";
import { ThemeProvider } from "./Context/ThemeContext";
import Base64 from "./Tools/EncoderDecoder/Base64";
import Base64URL from "./Tools/EncoderDecoder/Base64URL";
import URLencoder from "./Tools/EncoderDecoder/URLencoder";
import Htmlencoder from "./Tools/EncoderDecoder/Htmlencoder";
import Hex from "./Tools/EncoderDecoder/Hex";
import QuotedPrintable from "./Tools/EncoderDecoder/QuotedPrintable";
import HMACCalculator from "./Tools/Crypto/HMACCalculator";
import AsciiEncoder from "./Tools/EncoderDecoder/AsciiEncoder";
import JWTEncode from "./Tools/Crypto/JWTEncode";
import HashGenerator from "./Tools/Crypto/HashGenerator";
import Argon2Hash from "./Tools/Crypto/Argon2Hash";
import CaseConverter from "./Tools/TextUtilities/CaseConverter";
import Counters from "./Tools/TextUtilities/Counters";
import EscapeUnescape from "./Tools/TextUtilities/EscapeUnescape";
import WhiteSpaceTrim from "./Tools/TextUtilities/whiteSpaceTrim";
import LorumIpsumGenerator from "./Tools/TextUtilities/LorumIpsumGenerator";
import UUIDGenerator from "./Tools/TextUtilities/UUIDGenerator";
import RandomStringGenerator from "./Tools/TextUtilities/RandomStringGenerator";
import ColorPicker from "./Tools/TextUtilities/ColorPicker";
import BcryptPassword from "./Tools/Crypto/BcryptPasword";
import XMLFormatter from "./Tools/DataFormatTools/XMLFormatter";
import HTMLFormatter from "./Tools/DataFormatTools/HTMLFormatter";
import HTMLStripper from "./Tools/DataFormatTools/HTMLStripper";
import MarkdownToHTML from "./Tools/DataFormatTools/MarkdownToHTML";
import TimeZoneConverter from "./Tools/DateTimeTools/TimeZoneConverter";
import CronGeneratorParser from "./Tools/DateTimeTools/CronGeneratorParser";
import JSONtoSQLConverter from "./Tools/DBTools/JSONtoSQLConverter";
import CSVtoSQLConverter from "./Tools/DBTools/CSVtoSQLConverter";
import FindReplace from "./Tools/TextUtilities/FindReplace";
import RegexTester from "./Tools/TextUtilities/RegexTester";
import TimeDifferenceCalculator from "./Tools/DateTimeTools/TimeDifferenceCalculator";
import TimeStampConverter from "./Tools/DateTimeTools/TimeStampConverter";
import TextDifferece from "./Tools/DifferenceTools/TextDifference";
import CSVDifference from "./Tools/DifferenceTools/CSVDifference";
import XMLDifference from "./Tools/DifferenceTools/XMLDifference";
import CSVMultiDiffViewer from "./Tools/DifferenceTools/CSVMultiDiffViewer";
import XMLMultiDiffViewer from "./Tools/DifferenceTools/XMLMultiDiffViewer";
import TextMultiDiffViewer from "./Tools/DifferenceTools/TextMultiDiffViewer";
import ImageTools from "./Tools/ImagePDFTools/ImageTools";
import Base64ImageTools from "./Tools/ImagePDFTools/Base64ImageTools";
import PDFImageConverter from "./Tools/ImagePDFTools/PDFImageConverter";
import PDFMergerSplitter from "./Tools/ImagePDFTools/PDFMergerSplitter";
import Whiteboard from "./Tools/ImagePDFTools/Drawio";

import DocxtoPDFConverter from "./Tools/ImagePDFTools/DocxtoPDFConverter";
import DocxtoMarkdown from "./Tools/ImagePDFTools/DocxtoMarkdown";
import APITool from "./Tools/DataFormatTools/APITool";
const MarketingHome = lazy(() => import('./Marketing/MarketingHome'));



function LegacyToolRedirect() {
  const location = useLocation();
  const known = /^\/(JSON(?:%20| )Tools|encode|crypto|text|generators|time|diff|data|api-diagram|db|media|documents|json-diff-view|text-diff-view|csv-diff-view|xml-diff-view)(\/|$)/;
  if (location.pathname === '/' || known.test(location.pathname)) {
    return <Navigate replace to={'/app/tools' + (location.pathname === '/' ? '' : location.pathname) + location.search + location.hash} state={location.state} />;
  }
  return <div className="auth-status"><h1>Page not found</h1></div>;
}

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Suspense fallback={<div role="status">Loading Cobygo…</div>}><MarketingHome /></Suspense>} />
            <Route element={<AuthProvider type="platform" />}>
              <Route path="/platform-admin/login" element={<LoginPage key="platform-login" />} />
              <Route element={<RequireAuth role="COBYGO_ADMIN" />}>
                {platformAdminRoutes()}
              </Route>
            </Route>
            <Route element={<AuthProvider type="tenant" />}>
              <Route path="/login" element={<LoginPage key="tenant-login" />} />
              <Route path="/password/setup" element={<PasswordSetupPage />} />
              <Route path="/setup/invitation" element={<TenantAdminSetupPage />} />
              <Route element={<RequireAuth />}>
                <Route element={<SsoReentry />}>
                  <Route element={<RequireAuth role="TENANT_ADMIN" />}>
                    {tenantAdminRoutes()}
                  </Route>
            <Route path="/app/tools" element={<Layout />}>
              <Route index element={<HomePage />} />
              {/* Tools */}
              <Route path="JSON Tools/formatter" element={<JSONFormatter />} />
              <Route path="JSON Tools/validator" element={<JSONValidator />} />
              <Route path="JSON Tools/Convertors" element={<JSONConvertor />} />
              <Route path="JSON Tools/Difference" element={<JSONMultiDiff />} />
              <Route path="json-diff-view" element={<JSONMultiDiffViewer />} />
              <Route path="JSON Tools/Evaluator" element={<JSONEvaluator />} />
              {/* Tools Layout */}
              <Route path="JSON Tools" element={<ToolsLayout />} />
              <Route path="encode" element={<ToolsLayout />} />
              <Route path="crypto" element={<ToolsLayout />} />
              <Route path="text" element={<ToolsLayout />} />
              <Route path="generators" element={<ToolsLayout />} />
              <Route path="time" element={<ToolsLayout />} />
              <Route path="diff" element={<ToolsLayout />} />
              <Route path="data" element={<ToolsLayout />} />
              <Route path="api-diagram" element={<ToolsLayout />} />
              <Route path="db" element={<ToolsLayout />} />
              <Route path="media" element={<ToolsLayout />} />
              <Route path="documents" element={<ToolsLayout />} />



              {/* Encode/Decode */}
              <Route path="encode/base64" element={<Base64 />} />
              <Route path="encode/base64url" element={<Base64URL />}/>
               <Route path="encode/URL" element={<URLencoder />}/>
              <Route path="encode/html" element={<Htmlencoder />}/> 
              <Route path="encode/hex" element={<Hex />}/>
              <Route path="encode/quoted_printable" element={<QuotedPrintable />}/> 
              <Route path="encode/ascii" element={<AsciiEncoder />}/>
              {/* Crypto & Security */}
              <Route path="crypto/hash" element={<HashGenerator />}/>
              <Route path="crypto/hmac" element={<HMACCalculator />}/>
              <Route path="crypto/argon2" element={<Argon2Hash />}/>
              <Route path="crypto/jwt" element={<JWTEncode />}/>
              <Route path="crypto/bcrypt" element={<BcryptPassword />}/>
              {/* Text Utilities */}
              <Route path="text/caseconverters" element={<CaseConverter />}/>
              <Route path="text/counters" element={<Counters />} />
              <Route path="text/escape-unescape" element={<EscapeUnescape />}/>
              <Route path="text/whitespace-trim" element={<WhiteSpaceTrim />}/>
              <Route path="text/lorem-ipsum-generator" element={<LorumIpsumGenerator />}/>
              <Route path="text/uuid-generator" element={<UUIDGenerator />}/>
              <Route path="text/random-string-generator" element={<RandomStringGenerator />}/>
              <Route path="text/color-picker" element={<ColorPicker />}/>
              <Route path="text/find-replace" element={<FindReplace />}/>
              <Route path="text/regex-tester" element={<RegexTester />}/>
              {/* Time & Date */}
              <Route path="time/CronParser" element={<CronGeneratorParser/>} />
              <Route path="time/timezone" element={<TimeZoneConverter  />} />
              <Route path="time/time-difference" element={<TimeDifferenceCalculator />} />
              <Route path="time/time-stamp" element={<TimeStampConverter />} />


              {/* Data Format */}
              <Route path="data/xmlFormatter" element={<XMLFormatter />}/>
              <Route path="data/htmlFormatter" element={<HTMLFormatter/>}/>
              <Route path = "data/htmlStripper" element = {<HTMLStripper/>}/>
              <Route path="data/htmlConverter" element={<MarkdownToHTML/>}/>
              <Route path="data/api-tool" element={<APITool />} />

              {/* Diff Tools */}
              <Route path="diff/text"element={<TextDifferece />} />
              <Route path="text-diff-view" element={<TextMultiDiffViewer />} />
              <Route path="diff/CSV"element={<CSVDifference />} />
              <Route path="csv-diff-view" element={<CSVMultiDiffViewer />} />
              <Route path="xml-diff-view" element={<XMLMultiDiffViewer />} />
              <Route path="diff/XML"element={<XMLDifference/>} />

              {/* Database Tools */}
              <Route path="db/jsontoSQL" element={<JSONtoSQLConverter/>}/>
              <Route path="db/csvtoSQL" element={<CSVtoSQLConverter />}/>

              {/* Image / PDF */}
              <Route path="media/image-tools" element={<ImageTools />} />
              <Route path="media/base64-image" element={<Base64ImageTools />} />
              <Route path="media/pdf-image" element={<PDFImageConverter />} />
              <Route path="media/pdf-merger" element={<PDFMergerSplitter />} />
              <Route path="media/whiteboard" element={<Whiteboard />} />
              <Route path="media/docxtopdf" element={<DocxtoPDFConverter />} />
              <Route path="media/docxtomarkdown" element={<DocxtoMarkdown />} />
              <Route path="*" element={<div className="auth-status">Tool not found.</div>} />
            </Route>
                </Route>
              </Route>
            </Route>
            <Route path="*" element={<LegacyToolRedirect />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
